import { useState, useEffect } from "react";

export default function FloatingLineButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <a
      href="https://lin.ee/xiNNjjf"
      rel="nofollow"
      target="_blank"
      className={`fixed z-40 transition-all duration-500 ${
        visible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0 pointer-events-none"
      } bottom-4 right-4 md:bottom-6 md:right-6 flex items-center gap-2 px-4 py-3 bg-redbean-primary text-redbean-cream font-semibold rounded-full shadow-card hover:bg-redbean-coffee transition-colors whitespace-nowrap text-sm md:text-base cursor-pointer min-h-[44px]`}
      aria-label="加入 LINE 詢問"
    >
      <span className="w-5 h-5 flex items-center justify-center">
        <i className="ri-chat-3-line" />
      </span>
      加入 LINE 詢問
    </a>
  );
}